import { AUTH_ENABLED } from './msalConfig';
import { getMsalInstance } from './msalInstance';

/**
 * Returns the email (preferred_username) of the currently logged-in user.
 * Returns null when auth is disabled (DevMode) or no account is active yet.
 *
 * MSAL's account.username is the same value as the JWT's preferred_username claim
 * (i.e. the user's email like "daniel@adelante.cr").
 */
export function getCurrentUserEmail(): string | null {
  if (!AUTH_ENABLED) return null;
  try {
    const instance = getMsalInstance();
    const account = instance.getActiveAccount();
    return account?.username ?? null;
  } catch {
    // getMsalInstance throws if AUTH_ENABLED is false; we already checked but defensive.
    return null;
  }
}

/**
 * Returns the display name of the currently logged-in user (e.g. "Daniel Navarro Jiménez").
 * Returns null when auth is disabled or no account is active.
 */
export function getCurrentUserName(): string | null {
  if (!AUTH_ENABLED) return null;
  try {
    const instance = getMsalInstance();
    const account = instance.getActiveAccount();
    return account?.name ?? null;
  } catch {
    return null;
  }
}